import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import $ from 'jquery';
import loadable from '@loadable/component'
import Upload from "./components/Upload";
import UploadView from "./components/UploadView";
import Checkin from "./components/Checkin";
import { doRequest, parseURLParams } from "./utils/helper";
import UserDetails from "./components/UserDetails";

const Home = loadable(() => import("./components/Home"));
const Gallery = loadable(() => import("./components/Gallery"));
// const Upload = loadable(() => import("./components/Upload"));
// const Profile = loadable(() => import("./components/Profile"));
const Event = loadable(() => import("./components/Event"));
// const ImageSlide = loadable(() => import("./components/ImageSlide"));
const Detail = loadable(() => import("./components/Detail"));




const AppRouter = () => {
  let history = useNavigate();

  const [loader, setLoader] = useState(false);
  // const getuserdetails = async () => {
  //   let formData = new FormData();

  //   var url_string = window.location.href; //window.location.href
  //   var url = new URL(url_string);
  //   var userid = url.searchParams.get("userid");


  //   formData.append("token", "ddd913e233f8bb3549b4a528278d8815");
  //   formData.append(
  //     "userid",
  //     userid
  //   );
  //   let data = await axios({
  //     method: "post",
  //     url: "https://api.narendramodi.in/api/getuserdata",
  //     data: formData,
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });
  //   if (data.data && data.data._resultflag === "1") {
  //     let userData = JSON.stringify(data.data.data[0]);
  //     localStorage.setItem("userData", userData);
  //   }
  // };
  useEffect(() => {
    let url = window.location.href;
    if (url.includes("userid")) {
      let userData = localStorage.getItem("userData");

      // if (!userData) {
        // getuserdetails();
      // }
    }
  }, []);


  return (
    <>
      {/* {loader && <Loader />} */}
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/upload" element={<Upload />} />
        <Route exact path="/checkin" element={<Checkin />} />
        <Route exact path="/uploadview" element={<UploadView />} />
        <Route path="/userdetails" element={<UserDetails />}></Route>
        <Route exact path="/gallery" element={<Gallery />} />
        <Route path="/event/:name" element={<Event />} />
        <Route path="/:id" element={<Detail />} />
      </Routes>
    </>
  );
};

export default AppRouter;
